// src/pages/DoctorPage/hooks/useDoctorList.js
import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { getDoctorListApi } from 'api/auth.api';

const EMPTY_ARRAY = [];

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const useDoctorList = (page, searchString = '') => {
  const toast = useToast();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['doctor-list', page, searchString],
    queryFn: () =>
      getDoctorListApi({
        page,
        searchString,
      }),
    select: (res) => res?.data || {},
    onError: (error) => {
      toast({
        title: getErrorMessage(error, 'Failed to fetch list'),
        status: 'error',
      });
    },
  });

  return {
    doctors: data?.result || [],
    totalPages: data?.totalPages || 1,
    isLoading: isLoading || isFetching,
  };
};
